import api from '../../services/api';
import { call, put } from 'redux-saga/effects';
import { Creators } from '../ducks/treemap_product';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getTreeMapProduct({ filter }) {
  try {
    yield put(Creators.treeMapProductRequest());
    const response = yield call(api.post, 'treemap', filter);

    yield put(Creators.treeMapProductSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.treeMapProductError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao exibir treemap'
    }));
  }
}